import { createSelector } from 'reselect';
import { getProfileState } from 'src/modules/profile/selectors/getProfileState';

export const getProfileSyncState = createSelector([
  getProfileState,
], (state) => state.state);
